import useGlobalSettings from "@components/_hooks/useGlobalSettings";

const useShowCallback = () => {
	const {getSetting} = useGlobalSettings();
	const show_callback = getSetting('request_callback', 'yes');
    return show_callback == 'yes';
}

export default useShowCallback;